// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "host" + "." + "f6beb4fcfffb1ea6a5ce" + ".min.css";
};